<template>
    <v-container fluid no-gutters class="mx-0 px-0" style="font-family: Arial, sans-serif; font-size: 22px;">
        <v-row justify="center" align="center">
            <v-col cols="12" align="center">
                <div class="rails-layout">
                    <span class="side-rail left -lg -lg" :style="{ backgroundColor: match.team1.color }">
                        <v-avatar style="border-radius: 10px;" size="100" color="white">
                            <img
                                height="auto"
                                width="100px"
                                :src="`${assetsUrl}/${match.team1?.logo}`"
                            >
                        </v-avatar>
                    </span>

                    <v-card class="stats-card px-10 mx-0 py-2" width="700px">
                        <v-row v-for="(stat, index) in stats" :key="index" justify="center" align="center" class="bottom-border py-1">
                            <v-col cols="3" align="end">
                                <span :class="stat.team1[stat.value] > stat.team2[stat.value] ? 'font-weight-black' : 'font-weight-regular'">
                                    {{ stat.team1[stat.value] }}
                                </span>
                            </v-col>
                            <v-col cols="6" align="center">
                                <span class="font-weight-bold purple--text">{{ stat.text }}</span>
                            </v-col>
                            <v-col cols="3" align="start">
                                <span :class="stat.team2[stat.value] > stat.team1[stat.value] ? 'font-weight-black' : 'font-weight-regular'">{{ stat.team2[stat.value] }}</span>
                            </v-col>
                        </v-row>
                    </v-card>

                    <span class="side-rail right -lg -lg" :style="{ backgroundColor: match.team2.color }">
                        <v-avatar style="border-radius: 10px;" size="100" color="white">
                            <img
                                height="auto"
                                width="100px"
                                :src="`${assetsUrl}/${match.team2?.logo}`"
                            >
                        </v-avatar>
                    </span>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                headers: [
                    {
                        text: 'Club',
                        align: 'start',
                        value: 'club',
                        width: '220px',
                        sortable: false
                    }
                ],
                periods: [
                    {
                        club: 'Olympiacos',
                        period1: {
                            value: 20,
                            color: false
                        },
                        period2: {
                            value: 25,
                            color: true
                        },
                        period3: {
                            value: 20,
                            color: false
                        },
                        period4: {
                            value: 23,
                            color: true
                        },
                        image: 'https://upload.wikimedia.org/wikipedia/en/thumb/7/7f/Olympiacos_BC_logo.svg/1200px-Olympiacos_BC_logo.svg.png'
                    },
                    {
                        club: 'Los Angeles Lakers',
                        period1: {
                            value: 23,
                            color: true
                        },
                        period2: {
                            value: 18,
                            color: false
                        },
                        period3: {
                            value: 25,
                            color: true
                        },
                        period4: {
                            value: 13,
                            color: false
                        },
                        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Los_Angeles_Lakers_logo.svg/1200px-Los_Angeles_Lakers_logo.svg.png'
                    }
                ],
                stats: [
                    { text: 'Points', value: 'points', team1: { player: null, points: 0 }, team2: { player: null, points: 0 } },
                    { text: '2Point FG%', value: 'two_points_percentage', team1: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 }, team2: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 } },
                    { text: '3Point FG%', value: 'three_points_percentage', team1: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 }, team2: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 } },
                    { text: 'Free Throws%', value: 'free_throw_percentage', team1: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 }, team2: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 } },
                    { text: 'Offensive Rebounds', value: 'offensiveRebounds', team1: { player: null, offensiveRebounds: 0 }, team2: { player: null, offensiveRebounds: 0 } },
                    { text: 'Defensive Rebounds', value: 'defensiveRebounds', team1: { player: null, defensiveRebounds: 0 }, team2: { player: null, defensiveRebounds: 0 } },
                    { text: 'Total Rebounds', value: 'rebounds', team1: { player: null, rebounds: 0 }, team2: { player: null, rebounds: 0 } },
                    { text: 'Assists', value: 'assists', team1: { player: null, assists: 0 }, team2: { player: null, assists: 0 } },
                    { text: 'Steals', value: 'steals', team1: { player: null, steals: 0 }, team2: { player: null, steals: 0 } },
                    { text: 'Turnovers', value: 'turnovers', team1: { player: null, turnovers: 0 }, team2: { player: null, turnovers: 0 } },
                    { text: 'Blocks', value: 'blockedShots', team1: { player: null, blockedShots: 0 }, team2: { player: null, blockedShots: 0 } },
                    { text: 'Personal Fouls', value: 'personalFouls', team1: { player: null, personalFouls: 0 }, team2: { player: null, personalFouls: 0 } }
                ]
            }
        },
        watch: {
            match: {
                handler() {
                    this.stats = [
                        { text: 'Points', value: 'points', team1: { player: null, points: 0 }, team2: { player: null, points: 0 } },
                        { text: '2Point FG%', value: 'two_points_percentage', team1: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 }, team2: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 } },
                        { text: '3Point FG%', value: 'three_points_percentage', team1: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 }, team2: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 } },
                        { text: 'Free Throws%', value: 'free_throw_percentage', team1: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 }, team2: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 } },
                        { text: 'Offensive Rebounds', value: 'offensiveRebounds', team1: { player: null, offensiveRebounds: 0 }, team2: { player: null, offensiveRebounds: 0 } },
                        { text: 'Defensive Rebounds', value: 'defensiveRebounds', team1: { player: null, defensiveRebounds: 0 }, team2: { player: null, defensiveRebounds: 0 } },
                        { text: 'Total Rebounds', value: 'rebounds', team1: { player: null, rebounds: 0 }, team2: { player: null, rebounds: 0 } },
                        { text: 'Assists', value: 'assists', team1: { player: null, assists: 0 }, team2: { player: null, assists: 0 } },
                        { text: 'Steals', value: 'steals', team1: { player: null, steals: 0 }, team2: { player: null, steals: 0 } },
                        { text: 'Turnovers', value: 'turnovers', team1: { player: null, turnovers: 0 }, team2: { player: null, turnovers: 0 } },
                        { text: 'Blocks', value: 'blockedShots', team1: { player: null, blockedShots: 0 }, team2: { player: null, blockedShots: 0 } },
                        { text: 'Personal Fouls', value: 'personalFouls', team1: { player: null, personalFouls: 0 }, team2: { player: null, personalFouls: 0 } }
                    ]
                    this.getMatchValues()
                }
            }
        },
        created() {
            this.getMatchValues()
        },
        methods: {
            getStat(value, stat) {
                if (value === 'two_points_percentage') {
                    return `${stat.twoPointsMade}/${stat.twoPointAttempts}`
                } else if (value === 'three_points_percentage') {
                    return `${stat.threePointsMade}/${stat.threePointAttempts}`
                } else if (value === 'free_throw_percentage') {
                    return `${stat.freeThrowsMade}/${stat.freeThrowAttempts}`
                } else {
                    return ''
                }
            },
            getMatchValues() {
                this.stats.forEach((stat) => {
                    this.match.team1.players.forEach((player) => {
                        if (player.stats.length > 0) {
                            if (stat.value === 'two_points_percentage') {
                                stat.team1.twoPointAttempts += player.stats[0].twoPointAttempts
                                stat.team1.twoPointsMade += player.stats[0].twoPointsMade
                            } else if (stat.value === 'three_points_percentage') {
                                stat.team1.threePointAttempts += player.stats[0].threePointAttempts
                                stat.team1.threePointsMade += player.stats[0].threePointsMade
                            } else if (stat.value === 'free_throw_percentage') {
                                stat.team1.freeThrowAttempts += player.stats[0].freeThrowAttempts
                                stat.team1.freeThrowsMade += player.stats[0].freeThrowsMade
                            } else {
                                stat.team1[stat.value] += player.stats[0][stat.value]
                            }
                        }
                    })
                    stat.team1.two_points_percentage = (stat.team1.twoPointsMade / (stat.team1.twoPointAttempts ? stat.team1.twoPointAttempts : 1) * 100).toFixed(0)
                    stat.team1.three_points_percentage = (stat.team1.threePointsMade / (stat.team1.threePointAttempts ? stat.team1.threePointAttempts : 1) * 100).toFixed(0)
                    stat.team1.free_throw_percentage = (stat.team1.freeThrowsMade / (stat.team1.freeThrowAttempts ? stat.team1.freeThrowAttempts : 1) * 100).toFixed(0)
                    this.match.team2.players.forEach((player) => {
                        if (player.stats.length > 0) {
                            if (stat.value === 'two_points_percentage') {
                                stat.team2.twoPointAttempts += player.stats[0].twoPointAttempts
                                stat.team2.twoPointsMade += player.stats[0].twoPointsMade
                            } else if (stat.value === 'three_points_percentage') {
                                stat.team2.threePointAttempts += player.stats[0].threePointAttempts
                                stat.team2.threePointsMade += player.stats[0].threePointsMade
                            } else if (stat.value === 'free_throw_percentage') {
                                stat.team2.freeThrowAttempts += player.stats[0].freeThrowAttempts
                                stat.team2.freeThrowsMade += player.stats[0].freeThrowsMade
                            } else {
                                stat.team2[stat.value] += player.stats[0][stat.value]
                            }
                        }
                    })
                    stat.team2.two_points_percentage = (stat.team2.twoPointsMade / (stat.team2.twoPointAttempts ? stat.team2.twoPointAttempts : 1) * 100).toFixed(0)
                    stat.team2.three_points_percentage = (stat.team2.threePointsMade / (stat.team2.threePointAttempts ? stat.team2.threePointAttempts : 1) * 100).toFixed(0)
                    stat.team2.free_throw_percentage = (stat.team2.freeThrowsMade / (stat.team2.freeThrowAttempts ? stat.team2.freeThrowAttempts : 1) * 100).toFixed(0)
                })
            },
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            }
        }
    }
</script>

<style>
    .v-tabs:not(.v-tabs--vertical).v-tabs--right > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__next,
    .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
        display: none;
    }

    .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
    .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
    .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        text-align: center !important;
    }
</style>

<style scoped>

    .bottom-border {
        border-bottom: 1px solid rgb(231, 225, 225);
    }

    .winning-period {
        background: linear-gradient(#00f7d1, #00ec80);
    }

    .rails-layout {
        display: flex;
        align-items: stretch;         /* make rails match the tallest child (v-card) */
        justify-content: center;
    }

    .side-rail {
        width: 200px;                 /* your rail width */
        display: flex;                /* center logo inside the rail */
        align-items: center;
        justify-content: center;
    }

    .side-rail img {
        max-width: 100px;
        height: auto;
    }

</style>
